module.exports = new __parcel__URL__("find-ga-code.6fbdfe8f.png").toString();